import { OfferGridModel } from "./offerGridModel";
import { UserDropdownModel } from "../userDropdownModel";
import { OfferAdminModel } from "./offerAdminModel";
export class OfferTransferModel {
    public trader: UserDropdownModel;
    public offers: Array<OfferGridModel>;
    public adminOffers: Array<OfferAdminModel>;
}